<template>
    <div>
        <form class="mt-2" id="form-modal">
            <!-- title input -->
            <div class="form-group">
                <label class="label-form-mini" style="float: left">Company Name<span style="color: red">*</span>:</label>
                <label class="label-form-mini" style="float: right">Contact Name<span style="color: red">*</span>:</label>
                <input type="text" id="companyName" class="form-control-mini" v-model="formData.company" placeholder="Company Name*" @blur="checkLead"/>
                <input type="text" id="contactName" style="float: right" class="form-control-mini" v-model="formData.name" placeholder="Contact Name*" />
            </div>
            <div class="form-group">
                <label class="label-form-mini" style="float: left">Phone(with country code)<span style="color: red">*</span>:</label>
                <label class="label-form-mini" style="float: right">Email<span style="color: red">*</span>:</label>
                <input type="number" class="form-control-mini" v-model="formData.phone" placeholder="Phone (with country code)*" />
                <input type="text" style="float: right" class="form-control-mini" v-model="formData.email" placeholder="Email*" @blur="checkLead"/>
            </div>
            <div class="form-group">
                <label class="label-form">Country<span style="color: red">*</span>:</label>
                <multiselect v-model="formData.country" :options="countries" :multiple="false" :internal-search="true"  :selectedLabel="null" :deselectLabel="null"  :selectLabel="null"  :allow-empty="true"></multiselect>
            </div>
            <div class="form-group">
                <label class="label-form">Website<span style="color: red">*</span>:</label>
                <input type="text" @keyup="checkWebsiteStatus" class="form-control" v-model="formData.company_url" placeholder="Example : foxtek.com" />
                <font-awesome-icon v-if="isMiniLoading2" icon="spinner" style="animation: spin 2s linear infinite; float:right; margin-left: 0px; margin-top: -22px; margin-right:15px;" />
                <span v-show="company_url" style="color: red; font-size: 10px;">{{ this.company_url }}</span>
            </div>
            <div class="form-group">
                <label class="label-form">Software<span style="color: red">*</span>:</label>
                <multiselect @input="checkWebsiteStatus" :options="softwareOptions" :multiple="false"  :close-on-select="true" :clear-on-select="false"   
                 :selectedLabel="null" :deselectLabel="null" :selectLabel="null" :allow-empty="true"  v-model="software"
                label="name" track-by="id" style="font-size:12px !important"></multiselect>
            </div>
            <div class="form-group"  v-if="$can('lead_create_tags')">
          <label class="label-form">Lead Type</label>
        <multiselect v-model="lead_type" :options="selectLeadList" :multiple="false" :selectedLabel="null" :deselectLabel="null" :allow-empty="false"
        :selectLabel="null" :internal-search="true" label="name" track-by="name" placeholder="lead type">
        </multiselect>
    </div>

            <div>
                <label class="typo__label">Services That We Provide<span v-if="role_id != 6" style="color: red">*</span>:</label>
                <multiselect  @input="showCogDropDown" v-model="formData.services" placeholder="Search or add services*"  :options="options" :multiple="true" :taggable="true" :close-on-select="false" :clear-on-select="false" :internal-search="false"
                 :selectedLabel="null" :deselectLabel="null" :selectLabel="null" :allow-empty="true"></multiselect>
            </div>
            <div v-if="this.formData.show_cog_types" class="form-group mt-3">
                <label class="label-form">COG<span style="color: red">*</span>:</label>
                <multiselect v-model="formData.cog_types" :options="cogOptions" :multiple="true" :selectedLabel="null" :deselectLabel="null"  :selectLabel="null"
                    :close-on-select="false" :clear-on-select="false" :internal-search="false" :allow-empty="true" label="name" track-by="value"
                    :options-limit="20" :max-height="130" placeholder="Please select COG types*">
                </multiselect>
            </div>
            <div class="form-group mt-3">
                <label class="label-form">How did you hear about us ?</label>
                <textarea class="form-control" style="height: 42px" v-model="formData.hear_about" placeholder="How did you hear about us?"></textarea>
            </div>
            <div class="form-group">
                <label class="label-form">When Are You Looking To Implement The Software ?</label>
                <multiselect v-model="formData.implement_date" :options="joinOptions" :close-on-select="true" :internal-search="false" :selectedLabel="null" :deselectLabel="null"  :selectLabel="null"  :allow-empty="true" :options-limit="20" :max-height="130" placeholder="Select expected time duration to use the software? " track-by="id">
                </multiselect>
            </div>
            <div class="form-group">
                <label class="label-form">Tags:</label>
                <multiselect  v-model="formData.tags"  label="tag" track-by="id" :searchable="false"  :options-limit="20" :max-height="130" :selectLabel="null" :selectedLabel="null" :deselectLabel="null" :options="formData.all_tags" :multiple="true" :allow-empty="true"   :close-on-select="false" :clear-on-select="false"  placeholder="Tags"></multiselect>
            </div>
            <div class="form-group" v-if="[0,1,6].includes(role_id)">
                <label class="label-form">Assign Lead</label>
                <multiselect  v-model="formData.assign_to"  label="full_name" track-by="id" :searchable="false"  :options-limit="20" :max-height="130" :selectLabel="null" :selectedLabel="null" :deselectLabel="null" :options="formData.admin_users" :multiple="false" :allow-empty="true"   :close-on-select="false" :clear-on-select="false"  placeholder="Assign Lead"></multiselect>
            </div>
            <div>
                <div class="form-group">
                <h5 class="text-dark font-weight-bold py-2">Additional Information</h5>
                <label class="label-form-mini" style="float: left">Number of Decision Makers:</label>
                <label class="label-form-mini" style="float: right">Number of Employees:</label>
                <input type="text" id="numberOfDecisionMakers" class="form-control-mini" v-model="formData.number_of_decion_makers"
                    placeholder="Number of Decion Makers" />
                <input type="text" id="numberofEmployees" style="float: right" class="form-control-mini" v-model="formData.number_of_employees"
                    placeholder="Number of Employees" />
                </div>
                <div class="form-group">
                <label class="label-form-mini" style="float: left">Close Date:</label>
                <label class="label-form-mini" style="float: right">Street Address:</label>
                <input  id="comanyCloseDate" class="form-control-mini" placeholder="Close Date"  v-model="formData.close_date" type="text" />
                <input type="text" id="companyStreetAddress" style="float: right" class="form-control-mini" v-model="formData.street_address"
                    placeholder="Street Address" />
                </div>
                <div class="form-group">
                <label class="label-form-mini" style="float: left">Postal Code:</label>
                <label class="label-form-mini" style="float: right">Timezone:</label>
                <input type="text" id="companyPostalCode" class="form-control-mini" v-model="formData.postal_code"
                    placeholder="Postal Code" />
                <input type="text" id="companyTimezone" style="float: right" class="form-control-mini" v-model="formData.timezone"
                    placeholder="Timezone" />
                </div>
                <div class="form-group">
                    <label class="label-form-mini" style="float: left">Year Founded:</label>
                    <label class="label-form-mini" style="float: right">Facebook:</label>
                    <input  id="comanyYearFounded" class="form-control-mini" placeholder="Year Founded" type="text"  v-model="formData.year_founded" />

                    <input type="text" id="companyFacebook" style="float: right" class="form-control-mini" v-model="formData.facebook"
                        placeholder="Facebook Link" />
                </div>
                <div class="form-group">
                    <label class="label-form-mini" style="float: left">Google Plus:</label>
                    <label class="label-form-mini" style="float: right">Twitter:</label>
                
                    <input type="text" id="companyGoogle" class="form-control-mini" v-model="formData.goole_plus"
                        placeholder="Google Plus Link" />
                    <input type="text" id="companyTwitter" style="float: right" class="form-control-mini" v-model="formData.twitter"
                            placeholder="Twitter Link" />
                
                </div>
                <div class="form-group">
                    <label class="label-form-mini" style="float: left">LinkedIn:</label>
                    <label class="label-form-mini" style="float: right">Job Title:</label>
                    <input type="text" id="companyLinkedin" style="float: left" class="form-control-mini" v-model="formData.linked_in"
                    placeholder="LinkedIn Link" />
                    <input type="text" id="jobTitle" style="float: right" class="form-control-mini" v-model="formData.job_title"
                    placeholder="Job Title" />
                  
                </div>
            </div>
           
            <!-- buttons -->
            <div class="text-right" style="margin-top:6rem !important">
                <button type="button" class="btn btn-secondary text-light " data-dismiss="modal">
                    Close
                </button>
                <button type="button" :disabled="isMiniLoading1" :style= "[isMiniLoading1 ? { 'cursor' : 'default' } : { 'cursor' : 'pointer' }]" class="btn btn-default text-light ml-1" @click="save">
                    <font-awesome-icon v-if="isMiniLoading1" icon="spinner" style="animation: spin 2s linear infinite; float:right; margin-left: 5px; margin-top: 3px;" />
                    Update
                </button>
                <button type="button" :disabled="isMiniLoading" :style= "[isMiniLoading ? { 'cursor' : 'default' } : { 'cursor' : 'pointer' }]" class="btn btn-default text-light ml-1" @click="saveclose">
                    <font-awesome-icon v-if="isMiniLoading" icon="spinner" style="animation: spin 2s linear infinite; float:right; margin-left: 5px; margin-top: 3px;" />
                    Update/close
                </button>
            </div>
        </form>
    </div>
</template>

<script>
    import Multiselect from "vue-multiselect";
    import axios from 'axios';
    export default {
        components: {
            Multiselect
        },
        props: [
            'action', 'formData'
        ],
        data: function () {
            return {
                  lead_type: '',
                isMiniLoading: false,
                isMiniLoading1: false,
                isMiniLoading2: false,
                software: "",
                countries: [],
                value: [],
                options:['Linen Rentals', 'Customer Owned Goods', 'Dry Cleaning'],
                softwareOptions: {},

                joinOptions: ['As Soon as Possible', 'Within One Month', 'Within Two Months', 'Three Months+', 'Not Sure Yet'],
                company_url:"",
                additional_info:{
                    'number_of_decion_makers':'',
                    'number_of_employees':'',
                    'close_date':'',
                    'street_address':'',
                    'postal_code':'',
                    'timezone':'',
                    'year_founded':'',
                    'facebook':'',
                    'goole_plus':'',
                    'linked_in':'',
                    'twitter':'',
                    'job_title':'',
                            },
                            
                role_id: '',
                selected_tags:[],
                cogOptions:[
                    { name: 'By Piece', value: '1' },
                    { name: 'By Weight', value: '2' },
                ],
                cogOptionsSelected:[],
                showCog:false,
                cogTypes:[],
                userAssignedProduct :localStorage.getItem("user_product"),
            };
           
        },
        mounted: function(){
            this.role_id = localStorage.getItem('role');
        },
        
        created: function () {
      this.softwareOptions =  this.$store.getters['persist/availableProducts'];

     this.softwareOptions = this.softwareOptions.filter(product =>
         this.userAssignedProduct.includes(product.id)
        );
              const permission = {
                headers: {
                    'X-Permission': 'lead_set_followup_date' 
                }
                };
            axios.get('admin/users/countries',permission).then((response) => {
                this.countries = response.data.countries;
            });
             this.software = this.softwareOptions.find(option => option.id === this.formData.lead_for);
      },
        watch:{
        "formData.lead_for": {
            handler: function () {
              this.software = this.softwareOptions.find(option => option.id === this.formData.lead_for);
            },
            deep: true
          },
        },
        computed: {
      selectLeadList: function () {
        return this.$store.getters['persist/selectLeadList'];
      },
        },
        methods: {
         
async checkLead() {
     const { company, email } = this.formData;
     let companyName= company;

    if (companyName && email) {
        try {
            const response = await axios.post(
                '/admin/users/auto-fill-leads',
                { companyName, email },
                {
                    headers: {
                        'X-Permission': 'lead_create'
                    }
                }
            );
            if (response.data && response.data.existing_lead) {
                const existingLead = response.data.existing_lead;
                 this.formData = {...this.formData, ...existingLead};
                 this.formData.cog_types= existingLead.cog_type;
                 this.formData.services= [
                 existingLead.rental ? 'Linen Rentals' : null,
                  existingLead.cog ? 'Customer Owned Goods' : null,
                   existingLead.dry_cleaning ? 'Dry Cleaning' : null
                  ].filter(Boolean);
                  this.lead_type= this.selectLeadList.find(option => option.name === existingLead.lead_type);
                  this.software = this.softwareOptions.find(option => option.id === existingLead.lead_for);           
           }
        } catch (error) {
            if (error.response && error.response.status === 404) {
                console.log('No existing lead found.');
            } else {
                console.error('Error fetching data:', error);
            }
        }
    }
},

            saveclose(){
                let lead_type = this.lead_type ? this.lead_type.name : null; 
                let cog_types = ((this.formData.cog_types == undefined || this.formData.cog_types =='') || this.formData.services.indexOf('Customer Owned Goods') == -1 )?[] : this.formData.cog_types.map(({ value }) => value);
                let tag_ids = this.formData.tags.map(({ id }) => id);
                let services; 
                if(this.formData.services!= undefined){
                services =(this.formData.services.indexOf('Customer Owned Goods') != -1 && cog_types != '') || (this.formData.services != undefined && this.formData.services.indexOf('Customer Owned Goods') == -1 && cog_types.length == 0); 
                }else if((this.formData.services == "" || this.formData.services == undefined) && this.role_id == 6){
                services = true;
                }else{
                services = false;
                }
                if ((this.formData.company != undefined && this.formData.lead_for != undefined && this.formData.name != undefined && this.formData.company_url != undefined && this.formData.email != undefined && this.formData.phone != undefined && this.formData.country != undefined && (this.formData.services != undefined ||(this.formData.services == undefined && this.role_id == 6)))
                    &&
                    (this.formData.company != "" && this.formData.name != "" && this.formData.lead_for !== "" && this.formData.company_url != "" && this.formData.email != "" && this.formData.phone != "" && this.formData.country != "" && (this.formData.services.length > 0 ||( (this.formData.services.length == 0 || this.formData.services == undefined) && this.role_id == 6)))) {
                    if(services){
                        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.formData.email)) {
                            if(/[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g.test(this.formData.company_url)){
                            this.createclose(this.formData, this.formData.services, this.software,tag_ids,cog_types,lead_type);
                        }else{
                            this.$toast.error('Please enter a valid URL');
                        }
                            // this.createclose(this.formData, this.value, this.software);
                        }else{
                            this.$toast.error('Please enter a valid email address');
                        } 
                    }else{
                        this.$toast.error('Please select COG type');
                    }     
                } else {
                    this.$toast.warning('Fill all Required Fields');
                }
            },
            createclose(formData, SelectedServices, software, tag_ids,cog_types,lead_type) {
                let assign_to = this.formData.assign_to.id;
                this.additional_info.number_of_decion_makers= this.formData.number_of_decion_makers;
                this.additional_info.number_of_employees= this.formData.number_of_employees;
                this.additional_info.close_date=this.formData.close_date;
                this.additional_info.street_address=this.formData.street_address;
                this.additional_info.postal_code= this.formData.postal_code;
                this.additional_info.timezone=  this.formData.timezone;
                this.additional_info.year_founded=    this.formData.year_founded;
                this.additional_info.facebook=  this.formData.facebook;
                this.additional_info.goole_plus=  this.formData.goole_plus;
                this.additional_info.linked_in=    this.formData.linked_in;
                this.additional_info.twitter=  this.formData.twitter;
                this.additional_info.job_title = this.formData.job_title;           
                this.isMiniLoading = true;
                let search =  $(".demo-search").val();
                // if (software == "TheStaffer") {
                //     software = 1;
                // }
                // else {
                //     software = 0;
                // }
                // let services = [];
                // SelectedServices.forEach(key => {
                //     services.push(key.name);
                // });
                this.$store.dispatch('users/updateDemoRequest', [formData, SelectedServices, software, this.additional_info, tag_ids,cog_types,assign_to,lead_type])
                    .then((resp) => {
                        if(resp.error){
                            if(this.formData.lead_for == 1 ){
                            this.formData.lead_for = "TheStaffer";
                            }else{
                            this.formData.lead_for = "LinenTech";
                            }
                            this.isMiniLoading = false;
                            this.$toast.error(resp.error);
                        }else{
                            this.isMiniLoading = false;
                            this.$toast.success("Lead has been Updated Successfully!");
                            window.$('#modal').modal('hide');
                            if(search != ''){
                                this.$store.dispatch("users/getdemoBySearch", [1,search,this.formData.status,"", "", "", "","","","",'all','all','all',])
                            }else{
                                this.$store.dispatch('users/getAllDemoRequests', [this.formData.page, '', this.formData.status, '', '', '', '', '', '', this.formData.color ? this.formData.color : "", this.formData.followup_filter , localStorage.getItem('demo_filter'), localStorage.getItem('software_filter'),this.formData.assign_filter ? this.formData.assign_filter: "all", this.formData.crm_id ? this.formData.crm_id: 0,this.formData.tag_filter ? this.formData.tag_filter : 0]);
                                
                            }                        
                        // window.location.reload();
                        } 
                    })
                    .catch((error) => {
                        this.isMiniLoading = false;
                        this.$toast.error("Website Already Exists");
                    });
            },

            save() { 
                 let lead_type = this.lead_type ? this.lead_type.name : null;   
                let cog_types = ((this.formData.cog_types == undefined || this.formData.cog_types =='') || this.formData.services.indexOf('Customer Owned Goods') == -1 )?[] : this.formData.cog_types.map(({ value }) => value);
                let tag_ids = this.formData.tags.map(({ id }) => id);   
                let services;
                if(this.formData.services!= undefined){
                services =(this.formData.services.indexOf('Customer Owned Goods') != -1 && cog_types != '') || (this.formData.services != undefined && this.formData.services.indexOf('Customer Owned Goods') == -1 && cog_types.length == 0); 
                }else if((this.formData.services == "" || this.formData.services == undefined) && this.role_id == 6){
                services = true;
                }else{
                services = false;
                }   
                if
                 ((this.formData.company != undefined && this.formData.lead_for != undefined && this.formData.name != undefined && this.formData.company_url != undefined && this.formData.email != undefined && this.formData.phone != undefined && this.formData.country != undefined  && (this.formData.services != undefined ||(this.formData.services == undefined && this.role_id == 6)))
                    &&
                    (this.formData.company != "" && this.formData.name != "" && this.formData.lead_for !== "" && this.formData.company_url != "" && this.formData.email != "" && this.formData.phone != "" && this.formData.country != "" && (this.formData.services.length > 0 ||( (this.formData.services.length == 0 || this.formData.services == undefined) && this.role_id == 6)))) 
                    {
                    if(services){
                        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.formData.email)) {
                            if(/[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g.test(this.formData.company_url)){
                            this.create(this.formData, this.formData.services, this.software, tag_ids,cog_types,lead_type);
                            }else{
                                this.$toast.error('Please enter a valid URL');
                            }
                        }else{
                            this.$toast.error('Please enter a valid email address');
                        } 
                    }else{
                        this.$toast.error('Please select COG type');
                    }   
                } else {
                    this.$toast.warning('Fill all Required Fields');
                }
            },
            create(formData, SelectedServices, software, tag_ids,cog_types,lead_type) {
                this.isMiniLoading1 = true;
                let assign_to = this.formData.assign_to.id;
                this.additional_info.number_of_decion_makers= this.formData.number_of_decion_makers;
                this.additional_info.number_of_employees= this.formData.number_of_employees;
                this.additional_info.close_date=this.formData.close_date;
                this.additional_info.street_address=this.formData.street_address;
                this.additional_info.postal_code= this.formData.postal_code;
                this.additional_info.timezone=  this.formData.timezone;
                this.additional_info.year_founded=    this.formData.year_founded;
                this.additional_info.facebook=  this.formData.facebook;
                this.additional_info.goole_plus=  this.formData.goole_plus;
                this.additional_info.linked_in=    this.formData.linked_in;
                this.additional_info.twitter=  this.formData.twitter;
                this.additional_info.job_title=  this.formData.job_title;
                let search =  $(".demo-search").val();
                // if (software == "TheStaffer") {
                //     software = 1;
                // }
                // else {
                //     software = 0;
                // }
                // let services = [];
                // SelectedServices.forEach(key => {
                //     services.push(key.name);
                // });
                this.$store.dispatch('users/updateDemoRequest', [formData, SelectedServices, software, this.additional_info, tag_ids,cog_types,assign_to,lead_type])
                    .then((resp) => {
                         if(resp.error){
                            if(this.formData.lead_for == 1 ){
                                this.formData.lead_for = "TheStaffer";
                            }else{
                                this.formData.lead_for = "LinenTech";
                            }
                            this.isMiniLoading1 = false;
                            this.$toast.error(resp.error);
                             
                        }else{
                            // this.additional_info = {};
                             this.isMiniLoading1 = false;
                             this.$toast.success("Lead Updated Successfully!");
                        // window.$('#modal').modal('hide');
                        if(search != ''){
                                this.$store.dispatch("users/getdemoBySearch", [1,search,this.formData.status,"", "", "", "","","","",'all','all','all',])
                        }else{
                            this.$store.dispatch('users/getAllDemoRequests', [this.formData.page, '', this.formData.status, '', '', '', '', '', '', this.formData.color ? this.formData.color : "", this.formData.followup_filter , localStorage.getItem('demo_filter'), localStorage.getItem('software_filter'),this.formData.assign_filter ? this.formData.assign_filter: "all", this.formData.crm_id ? this.formData.crm_id:0 ,this.formData.tag_filter ? this.formData.tag_filter : 0]);
                        }
                       
                        // window.location.reload();
                        }
                       
                    })
                    .catch((error) => {
                       
                        this.isMiniLoading1 = false;
                        this.$toast.error(error);
                        // this.$toast.error("Website Already Exists");
                    });
            },
            checkWebsiteStatus(){
                    
                let lead_for = this.software ? this.software.id : 1;
                this.isMiniLoading2 = true;
                setTimeout(() => {
                    if(this.formData.company_url != ''){
                        if(/[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g.test(this.formData.company_url)){
                            this.$store.dispatch('users/checkLeadsWebsiteStatus',[this.formData.company_url,this.formData.lead_id,lead_for])
                            .then((error ) => {
                                this.company_url = error;
                                this.isMiniLoading2 = false;
                            });                   
                        }else{
                            this.company_url = "Please Enter a Valid URL";
                            this.isMiniLoading2 = false;
                        }
                    }
                    else{
                        this.company_url = '';
                        this.isMiniLoading2 = false;
                    }
                    
                },300);
            },
            showCogDropDown(){
                
            //    let service_values = Object.values(this.formData.services);
            //    console.log("show dropdown", this.formData.services,service_values.indexOf('Customer Owned Goods'));
              if(this.formData.services.indexOf("Customer Owned Goods") != -1){
                this.formData.show_cog_types = true;
              }else{
                this.formData.show_cog_types = false;
                this.formData.cog_types = [];
              }
              // this.showCog = this.demoForm.servicesValues.indexOf('Customer Owned Goods') != -1 ? true :false ;
            },
        },
    }
</script>
<style scoped>
input[type="date"]{
  position: relative;
}
input[type="date"]::-webkit-calendar-picker-indicator {
    background-position: right;
    background-size: auto;
    cursor: pointer;
    position: absolute;
    bottom: 0;
    left: 0;
    top: 12px !important;
    right: 2%;
    width: auto;
}
.text-dark{
    color: rgb(72, 166, 166) !important;
}
</style>